import { Component, OnInit } from '@angular/core';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { AttributionConstants } from './attribution.constants'

@Component({
  selector: 'app-attributions',
  templateUrl: './attributions.component.html',
  styleUrls: ['./attributions.component.scss'],
})
export class AttributionsComponent implements OnInit {
  AttributionConstants: any = AttributionConstants
  constructor() {}

  ngOnInit() {}

  scrollToOpenPanel($event: NgbPanelChangeEvent): void {
    var panelHeader = document.getElementById($event.panelId + '-header');
    var offsetTop = 50;
    window.scroll({ top: panelHeader.offsetTop - offsetTop, left: 0, behavior: 'smooth' });
  }
}
